const ns = 'product-tile'

// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: 20,
        /* Optional */
        // loadProductFirst: true,
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'saleClass': 'on-sale',
    'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
    'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
    'vendorHtml': '<div>{{itemVendorLabel}}</div>',

    // Grid Template
    'productGridItemHtml': '<div class="{{ns}} image__bg-container" data-product-tile data-restricted-countries=\'{{itemRestrictedCountries}}\'>\
                              <figure class="{{ns}}__media">\
                                <a href="{{itemUrl}}" class="{{ns}}__image-link {{ns}}__bg image__bg">\
                                  <span class="{{ns}}__bg-gradient image__bg-gradient cover"></span>\
                                  <img src="{{itemThumbUrl}}" class="{{ns}}__image image-cover" alt="{{itemTitle}}">\
                                </a>\
                              </figure>\
                              <div class="{{ns}}__info ta--c">\
                                <div class="title-cursive {{ns}}__badge {{itemBadgeDisplayClass}}">\
                                  {{itemBadge}}\
                                </div>\
                                <strong class="title {{ns}}__title">\
                                  {{itemTitle}}\
                                </strong>\
                                <div class="copy rte {{ns}}__snippet">\
                                  {{itemSnippet}}\
                                </div>\
                                <a href="{{itemUrl}}" class="{{ns}}__info-link">\
                                  <span class="visually-hidden">View {{itemTitle}} product</span>\
                                </a>\
                              </div>\
                              <button type="button" class="product__button button" {{itemAddToCartAttr}} {{itemButtonAttr}} data-product-tile-button>\
                                <span class="button__text">\
                                  {{itemButton}}\
                                </span>\
                              </button>\
                              <strong class="{{ns}}__restricted-message hide" data-product-tile-restricted-message>{{itemRestrictedCountriesMessage}}</strong>\
                            </div>',


    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',

    // Sorting Template
    'sortingHtml': '<label for="bc-sf-filter-top-sorting-select" class="visually-hidden">' + bcSfFilterConfig.label.sorting + '</label><select id="collection-sort" class="collection-sort__input">\n\t\t\t{{sortingItems}}\n\t\t</select>\n\t',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    var firstVariantId
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }

    firstVariantId = firstVariant.id

    /*** Prepare custom theme data ***/
    const isBundle = this.getProductMetafield(data, 'accentuate', 'bundle_products') !== null ? true : false

    // get the bundle product ids
    var itemButton = data.available ? window.theme.strings.addToCart : window.theme.strings.notifyMe
    const bundleIds = []
    var bundlePrice = 0
    var bundleAvailable = true

    if (isBundle) {
        const bundleArray = this.getProductMetafield(data, 'accentuate', 'bundle_products').split('|')

        bundleArray.forEach(function(handle) {
            const bundleProductData = window.products[handle]
            if (!bundleProductData.available) bundleAvailable = false
            bundleIds.push(bundleProductData.id)
            bundlePrice += bundleProductData.price
        })

        itemButton = window.theme.strings.addToCartBundle
        if (!bundleAvailable) {
            itemButton = window.theme.strings.soldOut
        }
    }

    const tags = data.tags
    const badgeIndex = tags.findIndex(tag => tag.indexOf('badge:') !== -1)
    const badge = badgeIndex > -1 ? tags[badgeIndex].replace('badge:', '') : ''
    const badgeDisplayClass = badgeIndex > -1 ? '' : 'hidden'
    const restrictedCountries = []

    // add restrictedCountries to product-tile
    tags.forEach(function(tag) {
        if (tag.indexOf('Restricted Countries|') > -1) {
            restrictedCountries.push(tag.replace('Restricted Countries|', ''))
        }
    })

    /*** End Prepare custom theme data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Price
    let itemPriceHtml = onSale ? '<s data-product-price="sale">'+ this.formatMoney(data.compare_at_price_min * 100).replace('.00', '') + '</s>' : '<s data-product-price="sale" class="hidden"></s>'

    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    // Add onSale class
    var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add soldOut Label
    var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // Add onSale Label
    var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add custom theme attributes
    if (!isBundle) {
        itemPriceHtml += '<span data-product-price="original">' + this.formatMoney(data.price_min * 100).replace('.00', '') + '</span>'
        if (data.available) itemButton += ' - ' + itemPriceHtml
        itemHtml = itemHtml.replace(/{{itemAddToCartAttr}}/g, 'data-add-to-cart="{{itemId}}"')
        itemHtml = itemHtml.replace(/{{itemClassAttr}}/g, data.available ? '' : 'klaviyo-bis-trigger')
        itemHtml = itemHtml.replace(/{{itemButtonAttr}}/g, 'data-product-data=\'' + JSON.stringify(data).replace(/\'/g, "&apos;") + '\'')
    } else {
        itemPriceHtml += '<span data-product-price="original">' + this.formatMoney(bundlePrice).replace('.00', '') + '</span>'
        if (bundleAvailable) itemButton += ' - ' + itemPriceHtml
        itemHtml = itemHtml.replace(/{{itemButtonAttr}}/g, bundleAvailable ? '' : 'disabled')
        itemHtml = itemHtml.replace(/{{itemAddToCartAttr}}/g, 'data-add-to-cart-bundle="'+ bundleIds.join('|') + '"')
    }

    itemHtml = itemHtml.replace(/{{itemButton}}/g, () => itemButton)
    itemHtml = itemHtml.replace(/{{itemBadgeDisplayClass}}/g, badgeDisplayClass)
    itemHtml = itemHtml.replace(/{{itemBadge}}/g, badge)
    itemHtml = itemHtml.replace(/{{itemSnippet}}/g, this.getProductMetafield(data, 'accentuate', 'snippet'))

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, firstVariantId);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
    itemHtml = itemHtml.replace(/{{itemRestrictedCountriesMessage}}/g, window.theme.strings.productCardRestrictedMessage);
    itemHtml = itemHtml.replace(/{{itemRestrictedCountries}}/g, JSON.stringify(restrictedCountries));

    // Add namespace (always last)
    itemHtml = itemHtml.replace(/{{ns}}/g, ns)

    return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
    // // Add Description
    // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    // // Truncate by word
    // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
    // // Truncate by character
    // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
    // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.bottomPagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.bottomPagination).html(paginationHtml);
        }
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }

    // setSorterWidth()
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  if (data.total_product < 1) {
    document.documentElement.classList.add('collection--no-results')
  } else {
    document.documentElement.classList.remove('collection--no-results')
  }

  if (window.hasOwnProperty('AddToCart') && typeof window.AddToCart === 'function') {
    new window.AddToCart()
  }

  if (window.hasOwnProperty('restrictedCountries') && typeof window.restrictedCountries === 'function') {
    new window.restrictedCountries()
  }
};

jQ('body').on('click', '.bc-sf-search-suggestion-mobile-overlay', function() {
    closeSuggestionMobile('#bc-sf-search-box-mobile', true)
})


/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
